import { createFileRoute } from "@tanstack/react-router";
import { Technologie } from "../components/sections";
import { pageHead, technologyJsonLdScript } from "@/lib/seo";

const TITLE = "Technologie & stack — TanStack Start, Supabase | IT Solutions";
const DESC =
  "Onze technische stack: AI-gedreven ontwikkeling, TanStack Start & React front-ends, Supabase PostgreSQL database, wereldwijde edge-hosting, Tailwind CSS en Framer Motion.";

import { TechnologiePage } from "@/pages/technologie";

export const Route = createFileRoute("/technologie")({
  head: () => ({
    ...pageHead({ lang: "nl", pathWithoutLang: "/technologie", title: TITLE, description: DESC }),
    scripts: [technologyJsonLdScript("nl")],
  }),
  component: TechnologiePage,
});
